import { useTranslation } from 'react-i18next';

export default function Trust() {
  const { t } = useTranslation();

  const cards = [
    { icon: 'ri-shield-check-line', titleKey: 'trust_c1_title', descKey: 'trust_c1_desc' },
    { icon: 'ri-award-line', titleKey: 'trust_c2_title', descKey: 'trust_c2_desc' },
    { icon: 'ri-pulse-line', titleKey: 'trust_c3_title', descKey: 'trust_c3_desc' },
  ];

  const stats = [
    { valKey: 'trust_s1_val', labelKey: 'trust_s1_label' },
    { valKey: 'trust_s2_val', labelKey: 'trust_s2_label' },
    { valKey: 'trust_s3_val', labelKey: 'trust_s3_label' },
    { valKey: 'trust_s4_val', labelKey: 'trust_s4_label' },
  ];

  return (
    <section id="trust" className="py-16 md:py-28 bg-[#111418]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-medal-line text-yellow-400 text-sm"></i>
            <span className="text-yellow-400 text-xs font-semibold uppercase tracking-wide">{t('trust_badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-black text-white mb-4">
            {t('trust_title_1')} <span className="text-yellow-400">{t('trust_title_2')}</span>
          </h2>
          <p className="text-white/50 text-sm md:text-base max-w-xl mx-auto">{t('trust_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16">
          {cards.map((c) => (
            <div key={c.titleKey} className="bg-white/5 border border-white/10 rounded-2xl p-5 md:p-7 hover:border-yellow-500/30 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-yellow-500/10 rounded-xl mb-5">
                <i className={`${c.icon} text-yellow-400 text-2xl`}></i>
              </div>
              <h3 className="text-white font-bold text-base md:text-lg mb-3">{t(c.titleKey)}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{t(c.descKey)}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-yellow-900/20 via-yellow-800/10 to-yellow-900/20 border border-yellow-500/10 rounded-2xl p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {stats.map((s) => (
              <div key={s.valKey} className="text-center">
                <div className="text-yellow-400 font-black text-2xl md:text-4xl mb-1">{t(s.valKey)}</div>
                <div className="text-white/50 text-xs md:text-sm">{t(s.labelKey)}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-10 md:mt-12">
          <p className="text-white/50 text-sm md:text-base mb-6 max-w-lg mx-auto">{t('trust_cta_text')}</p>
          <button onClick={() => document.getElementById('calculator')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-400 text-white font-bold px-8 md:px-10 py-3.5 md:py-4 rounded-full transition-all duration-200 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap text-sm md:text-base">
            <i className="ri-calculator-line text-lg"></i>
            <span>{t('trust_cta_btn')}</span>
          </button>
        </div>
      </div>
    </section>
  );
}
